import { AdminBadge } from '@interfaces/api/admin-badge'
import { axiosPost } from '@services/api/axios'

export interface AdminBadgeCreatePayload {
  badge: number
}

export const apiAdminBadgeCreate = async (payload: AdminBadgeCreatePayload) =>
  await axiosPost<AdminBadgeCreatePayload, AdminBadge>('/external-app-plugin/admin-badges', payload)
